export default __webpack_public_path__ + "static/media/shakeHand.8295636e.svg";